import type { Wws_Page, Wws_PageItem } from '../types/graphql';

export enum MessageType {
  EDIT_COVER_PHOTO = 'EDIT_COVER_PHOTO',
  EDIT_BASIC_INFO = 'EDIT_BASIC_INFO',
  EDIT_PAGE_ITEM = 'EDIT_PAGE_ITEM',
  EDIT_PAGE_TITLE = 'EDIT_PAGE_TITLE',
  EDIT_COUPLE_NAME = 'EDIT_COUPLE_NAME',
  EDIT_DATE_LOCATION = 'EDIT_DATE_LOCATION',
  DELETE_PAGE_ITEM = 'DELETE_PAGE_ITEM',
  EDIT_ANNOUNCEMENT_BANNER = 'EDIT_ANNOUNCEMENT_BANNER',
}

interface EditPageItemData {
  pageId: number;
  pageItemId: number;
  pageItemType: string;
  pageItemSubItemId?: number | string | undefined;
  fieldId: string | undefined;
}

interface DeletePageItemData {
  pageId: number;
  pageItemId: number;
  pageItemType: string;
  pageItemSubItemId: number | string | undefined;
}

interface EditBasicInfoData {
  fieldId: string | undefined;
}

interface EditPageTitleData {
  pageId: number;
}

type InlineEditMessageData = EditPageItemData | DeletePageItemData | EditBasicInfoData | EditPageTitleData;

interface PreviewMessage {
  type: MessageType | string;
  data: Wws_PageItem | string | Wws_Page | undefined | InlineEditMessageData;
}

export function sendPostMessage(message: PreviewMessage): void {
  if (window?.webkit?.messageHandlers?.['guestViewMessageHandler']) {
    window.webkit.messageHandlers['guestViewMessageHandler'].postMessage(JSON.stringify(message));

    return;
  }

  // If a window does not have a parent, its parent property is a reference to itself.
  if (window.parent === window) {
    return
  }

  window.parent.postMessage(JSON.stringify(message), '*');
}
